import request from '@/utils/request'

// 获取上传文件所需参数
export function getPostSignatureForOssUpload() {
  return request({
    url: '/file/getPostSignatureForOssUpload',
    method: 'get'
  })
}
